import React from "react";
import { Link, useParams } from "react-router-dom";
import { useGetPublicLearningResourceByIdQuery } from "../../services/api";
import "./LearningItemDetails.css";

export default function LearningItemDetails() {
  const { id } = useParams();
  const { data: resource, isLoading, error } = useGetPublicLearningResourceByIdQuery(id);

  if (isLoading) {
    return (
      <div className="lid-container">
        <Link className="welcome" to="/learning-library">
          ← Back Learning Library
        </Link>
        <div className="lid-loading">Loading resource details...</div>
      </div>
    );
  }

  if (error || !resource) {
    return (
      <div className="lid-container">
        <Link className="welcome" to="/learning-library">
          ← Back Learning Library
        </Link>
        <h1 className="username">Resource Not Found</h1>
        <div className="lid-error">
          The requested learning resource could not be found or an error occurred.
        </div>
      </div>
    );
  }

  // Determine the resource URL for the action button
  const getResourceUrl = () => {
    if (resource.sourceType === "url" && resource.url) {
      return resource.url;
    }
    if (resource.sourceType === "file" && resource.file?.path) {
      // Construct the full URL to the uploaded file
      const baseUrl = process.env.REACT_APP_API_URL || "";
      return `${baseUrl}/${resource.file.path}`;
    }
    return null;
  };

  const resourceUrl = getResourceUrl();

  return (
    <div className="lid-container">
      <Link className="welcome" to="/learning-library">
        ← Back Learning Library
      </Link>

      <h1 className="username">{resource.title}</h1>

      {/* Hero */}
      <section className="lid-hero">
        <div className="lid-hero-inner">
          <h2>Transform values into action</h2>
          <p>
            Turn your organization's values into clear, practical competencies
            that guide hiring, promotion, and staff engagement and development.
          </p>
        </div>
      </section>

      <div className="lid-card">
        <div className="lid-card-head">Resource Details</div>

        <div className="lid-details">
          <div className="lid-detail-row">
            <div className="lid-detail-label">Title</div>
            <div className="lid-detail-value">{resource.title}</div>
          </div>

          <div className="lid-detail-row">
            <div className="lid-detail-label">Type</div>
            <div className="lid-detail-value">
              <span className="lid-type-badge">{resource.type}</span>
            </div>
          </div>

          <div className="lid-detail-row">
            <div className="lid-detail-label">Description</div>
            <div className="lid-detail-value">
              {resource.description || "No description available."}
            </div>
          </div>

          <div className="lid-detail-row">
            <div className="lid-detail-label">Source</div>
            <div className="lid-detail-value">
              {resource.sourceType === "url" ? (
                <span className="lid-source-type">External Link</span>
              ) : (
                <span className="lid-source-type">Uploaded File</span>
              )}
            </div>
          </div>

          {resourceUrl && (
            <div className="lid-actions">
              {resource.sourceType === "url" ? (
                <a
                  href={resourceUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="lid-action-btn primary"
                >
                  Open Resource →
                </a>
              ) : (
                <a
                  href={resourceUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="lid-action-btn primary"
                >
                  Download File →
                </a>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
